const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const SingleOrgEmployeeList = ({employeeData, searchTerm, onSearchChange}) => {
  const filteredEmployeeData = Object.entries(employeeData).reduce(
    (acc, [letter, employees]) => {
      const filteredEmployees = employees.filter((employee) =>
        employee.fullName.toLowerCase().includes(searchTerm.toLowerCase()),
      );

      if (filteredEmployees.length > 0) {
        acc[letter] = filteredEmployees;
      }

      return acc;
    },
    {},
  );

  return (
    <>
      <div className='section-header'>
        <h2>All Employees</h2>
      </div>

      <div className='employee-search'>
        <input
          type='text'
          placeholder='Search employees'
          value={searchTerm}
          onChange={onSearchChange}
          className='search-input'
        />
      </div>

      <div className='employee-list-container'>
        <div className='employee-list'>
          {Object.keys(filteredEmployeeData).length > 0 ? (
            Object.entries(filteredEmployeeData).map(([letter, employees]) => (
              <div key={letter} className='letter-group'>
                <div className='letter-header'>{letter}</div>
                {employees.map((employee) => (
                  <div key={employee.id} className='employee-item'>
                    {employee.fullName}
                  </div>
                ))}
              </div>
            ))
          ) : (
            <div className='no-results'>No employees found</div>
          )}
        </div>

        <div className='alphabet-sidebar'>
          {ALPHABET.map((letter) => (
            <div
              key={letter}
              className={`alphabet-item ${employeeData[letter] ? 'active' : ''}`}
            >
              {letter}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SingleOrgEmployeeList;
